import { useState, useEffect } from "react";
import { useSearch, useLocation } from "wouter";

interface UseTemplateFromUrlResult {
  templateId: string | null;
  clearTemplateParam: () => void;
  setCreatingFromTemplate: (isCreating: boolean) => void;
}

const useTemplateFromUrl = (): UseTemplateFromUrlResult => {
  const search = useSearch();
  const [, navigate] = useLocation();
  const [templateId, setTemplateId] = useState<string | null>(null);

  // Parse URL query parameters to get template ID
  useEffect(() => {
    // Use window.location.search as fallback if useSearch() doesn't work correctly
    const searchString = search || window.location.search;
    // Remove leading ? if present
    const cleanSearch = searchString.startsWith("?")
      ? searchString.slice(1)
      : searchString;
    const urlParams = new URLSearchParams(cleanSearch);
    const templateFromUrl = urlParams.get("template");

    if (templateFromUrl) {
      setTemplateId(templateFromUrl);
    } else {
      setTemplateId(null);
    }
  }, [search]);

  // Function to clear the template parameter from URL
  const clearTemplateParam = () => {
    if (templateId) {
      // Remove the template parameter and navigate to the base path
      const currentPath = window.location.pathname;
      navigate(currentPath);
      setTemplateId(null);
    }
  };

  // Setter function for creating from template (no-op since state is not used)
  const setCreatingFromTemplate = (_isCreating: boolean) => {
    // This is a no-op as the state is not currently used
  };

  return {
    templateId,
    clearTemplateParam,
    setCreatingFromTemplate,
  };
};

export default useTemplateFromUrl;
